<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M10 2.25C5.71984 2.25006 2.25 5.71983 2.25 10C2.25 14.2802 5.71984 17.7499 10 17.75C12.6344 17.75 14.9611 16.4352 16.3604 14.4287C16.597 14.089 16.5134 13.6217 16.1738 13.3848C15.8341 13.148 15.3668 13.2317 15.1299 13.5713C13.9992 15.1926 12.1234 16.25 10 16.25C6.54827 16.2499 3.75 13.4517 3.75 10C3.75 6.54825 6.54827 3.75006 10 3.75C12.1231 3.75004 13.999 4.80821 15.1299 6.42871C15.3668 6.76823 15.8342 6.85192 16.1738 6.61523C16.5133 6.3783 16.597 5.91092 16.3604 5.57129C14.9612 3.56606 12.6346 2.25004 10 2.25Z"
            fill="currentColor"
        />
        <path
            d="M11.5303 6.46973C11.2374 6.17683 10.7626 6.17683 10.4697 6.46973L7.46973 9.46973C7.42134 9.51812 7.38396 9.5732 7.35156 9.62988C7.33603 9.65703 7.31971 9.68375 7.30762 9.71289C7.2869 9.76289 7.27212 9.81459 7.2627 9.86719C7.25497 9.91035 7.25 9.95462 7.25 10C7.25 10.045 7.25508 10.089 7.2627 10.1318C7.27206 10.1845 7.28696 10.2361 7.30762 10.2861C7.31968 10.3153 7.33606 10.342 7.35156 10.3691C7.38403 10.4261 7.42112 10.4817 7.46973 10.5303L10.4697 13.5303C10.7626 13.8232 11.2374 13.8232 11.5303 13.5303C11.8232 13.2374 11.8232 12.7626 11.5303 12.4697L9.81055 10.75L17 10.75C17.4142 10.75 17.75 10.4142 17.75 10C17.75 9.58579 17.4142 9.25 17 9.25L9.81055 9.25L11.5303 7.53027C11.8232 7.23738 11.8232 6.76262 11.5303 6.46973Z"
            fill="currentColor"
        />
    </svg>
</template>
